import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/lib/supabase";

export function N8nSettings() {
  const [settings, setSettings] = useState({
    n8n_url: "",
    n8n_webhook: "",
    n8n_api_key: ""
  });
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const { data, error } = await supabase
        .from('app_settings')
        .select('n8n_settings')
        .not('n8n_settings', 'is', null)
        .limit(1);

      if (error) throw error;
      
      if (data && data.length > 0) {
        console.log('Configuración n8n cargada:', data[0].n8n_settings);
        setSettings(data[0].n8n_settings || {});
      }
    } catch (error) {
      console.error('Error fetching n8n settings:', error);
      toast({
        title: "Error",
        description: "No se pudieron cargar los ajustes de n8n",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // Primero obtenemos el ID del registro existente
      const { data: existingData, error: fetchError } = await supabase
        .from('app_settings')
        .select('id')
        .not('n8n_settings', 'is', null)
        .limit(1);

      if (fetchError) throw fetchError;

      console.log('Guardando configuración n8n:', settings);

      if (existingData && existingData.length > 0) {
        // Actualizamos el registro existente
        const { error: updateError } = await supabase
          .from('app_settings')
          .update({
            n8n_settings: settings
          })
          .eq('id', existingData[0].id);

        if (updateError) throw updateError;
      } else {
        // Creamos un nuevo registro
        const { error: insertError } = await supabase
          .from('app_settings')
          .insert({
            n8n_settings: settings
          });

        if (insertError) throw insertError;
      }

      toast({
        title: "Éxito",
        description: "Configuración de n8n guardada correctamente"
      });

      // Forzar recarga de la página para actualizar el header
      window.location.reload();
    } catch (error) {
      console.error('Error saving n8n settings:', error);
      toast({
        title: "Error",
        description: "No se pudieron guardar los ajustes de n8n",
        variant: "destructive"
      });
    }
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow-sm">
        <h2 className="text-lg font-medium mb-4">Configuración de n8n</h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">
              URL de n8n
            </label>
            <Input
              value={settings.n8n_url}
              onChange={(e) => setSettings(prev => ({
                ...prev,
                n8n_url: e.target.value
              }))}
              placeholder="http://localhost:5678"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Webhook de n8n
            </label>
            <Input
              value={settings.n8n_webhook}
              onChange={(e) => setSettings(prev => ({
                ...prev,
                n8n_webhook: e.target.value
              }))}
              placeholder="webhook-id"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              API Key de n8n
            </label>
            <Input
              type="password"
              value={settings.n8n_api_key}
              onChange={(e) => setSettings(prev => ({
                ...prev,
                n8n_api_key: e.target.value
              }))}
              placeholder="Tu API Key de n8n"
            />
          </div>
        </div>
      </div>

      <div className="flex justify-end">
        <Button type="submit">
          Guardar Cambios
        </Button>
      </div>
    </form>
  );
} 